export default "__VITE_ASSET__BPEtBeRD__"